import React from "react";

import { FlexDiv } from "@/components/Atoms/Box";
import Button from "@/components/Atoms/Button";
import Loader from "@/components/Atoms/Loader";
import NameInput from "@/components/Molecules/HookFormInputs/V1/NameInput";
import PhoneInput from "@/components/Molecules/HookFormInputs/V1/PhoneInput";
import EmailInput from "@/components/Molecules/HookFormInputs/V1/EmailInput";
import ErrorUI from "@/components/Atoms/InputsV2/ErrorUI";

import { classNameGenerator } from "@/utils";

import styles from "./DownloadPDFForm.module.scss";

interface FormInputProps {
  control: any;
  isLoading?: boolean;
  showNameField?: boolean;
  namePlaceholder: string;
  showPhoneField?: boolean;
  phonePlaceholder: string;
  showEmailField?: boolean;
  emailPlaceholder: string;
  handleBlur?: () => void;
  formError: {
    message: string;
    type: string;
  };
}

const FormInput: React.FC<FormInputProps> = ({
  control,
  isLoading,
  showNameField,
  namePlaceholder,
  showPhoneField,
  phonePlaceholder,
  showEmailField,
  emailPlaceholder,
  handleBlur = () => {},
  formError,
}) => {
  const cls = classNameGenerator(styles);

  const nameField = showNameField && (
    <NameInput
      className={cls("name")}
      name="name"
      control={control}
      placeholder={namePlaceholder}
    />
  );

  const phoneField = showPhoneField && (
    <PhoneInput
      className={cls("phone")}
      name="mobile"
      control={control}
      placeholder={phonePlaceholder}
      onBlur={handleBlur}
    />
  );

  const emailField = showEmailField && (
    <EmailInput
      className={cls("email")}
      name="email"
      control={control}
      placeholder={emailPlaceholder}
      onBlur={handleBlur}
    />
  );

  const primaryCTA = (
    <FlexDiv justifyContent="center">
      <Button isLoading={isLoading} className={cls("button")} type="submit">
        <span>Submit details</span>
        {isLoading && (
          <>
            &nbsp; <Loader />
          </>
        )}
      </Button>
    </FlexDiv>
  );

  return (
    <>
      {nameField}
      {phoneField}
      {emailField}
      {formError?.message && <ErrorUI error={formError?.message} />}
      {primaryCTA}
    </>
  );
};

export default FormInput;
